import styled from "styled-components";
import { openButton } from "../../../../../../utils/z-index";
import { colors } from "../../../../../../utils";
import { getHolidayGradient } from "../../../../../../utils/complex-styles";

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    flex: 1 1 auto;
  }
`;

export const CalendarHeaderContainer = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  justify-content: space-around;

  @media (min-width: 600px) {
    justify-content: space-between;
  }
`;

export const CenteredGridContainer = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: 0 auto 0 auto;
`;

export const GridBlock = styled.div`
  margin: 0 10px 0 10px;
  display: flex;
  justify-content: center;
  width: 200px;
`;

export const CalendarDay = styled.div<{
  workday?: boolean;
  holiday?: boolean;
  topLine?: boolean;
}>`
  min-height: 60px;
  min-width: 40px;
  position: ${(props) => (props.topLine ? "sticky" : "relative")};
  top: ${(props) => (props.topLine ? "0" : "")};
  z-index: ${(props) => (props.topLine ? openButton : "0")};
  border-top: ${(props) => (props.topLine ? "1px solid #dadce0" : "")};
  border-bottom: 1px solid #dadce0;
  background: ${(props) =>
    props.holiday
      ? getHolidayGradient(props.theme)
      : props.workday
      ? props.theme.colors.white
      : props.topLine
      ? props.theme.colors.misc3
      : "#F5F5F5"};
  border-right: 1px solid #dadce0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  @media screen and (min-width: 1200px) {
    min-width: auto;
  }
`;

export const Delimiter = styled.div<{ small?: boolean }>`
  border-left: 1px solid lightgrey;
  width: ${(props) => (props.small ? "10px" : "20px")};
  height: ${(props) => (props.small ? "14px" : "28px")};
`;

export const RightFilterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ButtonContainer = styled.div`
  border: 1px solid lightgrey;
  display: inline-flex;
  width: fit-content;
  align-items: center;
  border-radius: 5px;
  overflow: hidden;
`;

export const ButtonSwitch = styled.button<{ selected: boolean }>`
  position: relative;
  height: 40px;
  color: ${colors.gray2};
  border: none;
  background-color: ${(props) =>
    props.selected ? props.theme.colors.misc2 : props.theme.colors.white};
  padding: 0 10px 0 10px;
  font-size: 16px;
  &:hover {
    background-color: ${(props) =>
      props.selected ? props.theme.colors.misc2 : props.theme.colors.misc3};
    cursor: pointer;
  }
`;

export const CalendarLegend = styled.div<{
  holiday: boolean;
  workday: boolean;
}>`
  width: 26px;
  height: 26px;
  border-radius: 4px;
  border: 1px solid lightgrey;
  background: ${(props) =>
    props.holiday
      ? getHolidayGradient(props.theme)
      : props.workday
      ? props.theme.colors.white
      : props.theme.colors.grays7};
`;

export const EmployeeWrapper = styled.div<{ bg?: boolean }>`
  position: ${(props) => (props.bg ? "sticky" : "relative")};
  top: ${(props) => (props.bg ? "0" : "")};
  z-index: ${(props) => (props.bg ? openButton : "0")};
  top: 0;
  border-right: 1px solid lightgrey;
  border-left: 1px solid lightgrey;
  padding: 10px 10px 10px 10px;
  border-top: ${(props) => (props.bg ? "1px solid lightgrey" : "")};
  border-bottom: 1px solid lightgrey;
  min-height: 40px;
  background: ${(props) =>
    props.bg ? props.theme.colors.misc3 : props.theme.colors.white};
`;
